/**
 * Per-document reasons for a Processing Monitor bulk delete.
 *
 * The bulk-delete route already returns `results[]` with an `error` for every
 * document it could not delete (a template's source document, a missing row, a
 * database failure). The page used to render only "N failed — retry those
 * individually", which hid the one sentence that says what to do.
 *
 * Filenames come from the result when the server knows it, else from the rows
 * the page already holds, else the id — a failure is never unnamed.
 */

const REASON_LABELS = {
  not_found: 'Document not found (it may already have been deleted)',
};

export function describeBulkDeleteFailures(results, documents = []) {
  const filenameById = new Map((documents || []).map((d) => [d.id, d.filename]));
  return (results || [])
    .filter((r) => r && !r.ok)
    .map((r) => ({
      id: r.id,
      filename: r.filename || filenameById.get(r.id) || r.id,
      reason: REASON_LABELS[r.error] || r.error || 'Unknown error',
    }));
}
